import React, { Fragment } from 'react';
import { NavLink as RRNavLink, withRouter } from 'react-router-dom';
import { Collapse, Container, Navbar, NavItem, NavLink, NavbarToggler, Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import './SubNavMenu.css';
import locale from '../Locale';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../store/Configurator';
import { RouteComponentProps } from 'react-router-dom';
import ErrorModal from './ErrorModal';
import Helper from '../Helper';
import { history } from '../index';

interface IProps extends RouteComponentProps<any> {
	part: any;
	configuration: any;
	document?: any;
	user?: any;
	navCartOpen?: boolean;
	inquiryDialogOpen?: boolean;
	theme?: any;
}

interface IState {
	isOpen: boolean;
	confirmationModal: boolean;
	redirectUrl: string;
}

class SubNavMenu extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			isOpen: false,
			confirmationModal: false,
			redirectUrl: '',
		};
	}
	componentDidUpdate(prevProps: any) {
		if (prevProps.navCartOpen === true) {
			(this.props as any).setCartOpen(false);
		}
		if (prevProps.inquiryDialogOpen === true) {
			(this.props as any).setInquiryDialogOpen(false);
		}
	}
	toggle() {
		const state: IState = this.state;
		state.isOpen = !state.isOpen;
		this.setState(state);
	}
	toggleConfirmationModal(redirectUrl: string) {
		const state: any = this.state;
		state.confirmationModal = !this.state.confirmationModal;
		state.redirectUrl = redirectUrl;
		this.setState(state);
	}
	confirmRedirect() {
		const state: any = this.state;
		state.confirmationModal = !this.state.confirmationModal;
		this.setState(state);
		history.push(process.env.REACT_APP_ROOT_PATH + this.state.redirectUrl);
	}
	goToConfiguration() {
		history.push(process.env.REACT_APP_ROOT_PATH + '/admin/document/configuration');
	}
	render() {
		const baseName = (process.env.REACT_APP_ROOT_PATH || '').toLowerCase();
		const pathName = this.props.location.pathname.toLowerCase().replace(/\/$/, '');

		const checkActiveConfiguration = () => pathName.indexOf('admin/configuration') >= 0;
		const checkActiveDocument = () => pathName.indexOf('admin/document') >= 0;
		const checkActiveMyProjects = () => pathName.indexOf('admin/myprojects') >= 0;
		const checkActiveAllProjects = () => pathName.indexOf('admin/allprojects') >= 0;

		const checkActiveStep1 = () =>
			pathName === baseName + '/' ||
			pathName === baseName + '' ||
			pathName === baseName + '/configurator' ||
			pathName === baseName + '/configurator/selection' ||
			pathName === baseName + '/external-configurator' ||
			pathName === baseName + '/external-configurator/selection';

		const isStep1 = () => pathName.indexOf('configurator/selection') >= 0;
		const isStep2 = () => pathName.indexOf('configurator/configuration') >= 0;
		const isStep3 = () => pathName.indexOf('configurator/confirmation') >= 0;
		const isPublicDocuments = pathName.indexOf('documents') >= 0;
		const isExternal = pathName.indexOf('external-configurator') >= 0;

		const navTitle = checkActiveConfiguration()
			? locale.configurationEditing
			: checkActiveDocument()
				? locale.documentEditing
				: checkActiveMyProjects()
					? locale.myProjects
					: checkActiveAllProjects()
						? locale.allProjects
						: checkActiveStep1()
							? locale.configurationStep1
							: isStep2()
								? locale.configurationStep2
								: isStep3()
									? locale.configurationStep3
									: '';

		const adminVisible = Helper.userEditor();
		const headOfSalesVisible = Helper.userHeadOfSales();
		const installerVisible = Helper.userInstaller();

		const documentDisabled = !this.props.document || !this.props.document.documentId;
		const documentConfigurationDisabled =
			!this.props.configuration || !this.props.configuration.configurationId || !this.props.configuration.documentConfigurationId;
		const configurationDisabled = !this.props.configuration || !this.props.configuration.configurationId;

		const configurationVersion =
			this.props.configuration && this.props.configuration.documentPosition ? ' (' + this.props.configuration.documentPosition + ')' : '';

		const modelAndPriceDiv = (
			<Fragment>
				{this.props.document && this.props.document.documentId && this.props.document.project ? (
					<div
						className='model'
						onClick={
							isExternal
								? undefined
								: () => {
										// show confirmation dialog when admin is edition configuration
										if (pathName.indexOf('/admin') === -1)
											this.toggleConfirmationModal('/admin/myProjects?project=' + this.props.document.project);
										else history.push(process.env.REACT_APP_ROOT_PATH + '/admin/myProjects?project=' + this.props.document.project);
									}
						}
						style={{ cursor: isExternal ? 'default' : 'pointer' }}
					>
						<label className='smaller'>{locale.adminDocumentProject}</label>
						<div>
							<b>{this.props.document.project}</b>
						</div>
					</div>
				) : null}

				{this.props.document && this.props.document.documentId && this.props.document.name ? (
					<div
						className='model'
						onClick={
							isExternal
								? undefined
								: () => {
										// show confirmation dialog when admin is edition configuration
										if (pathName.indexOf('/admin') === -1) this.toggleConfirmationModal('/admin/document/configurations');
										else history.push(process.env.REACT_APP_ROOT_PATH + '/admin/document/configurations');
									}
						}
						style={{ cursor: isExternal ? 'default' : 'pointer' }}
					>
						<label className='smaller'>{locale.document}</label>
						<div>
							<b>
								{this.props.document.name}
								{configurationVersion}
							</b>
						</div>
					</div>
				) : null}

				{this.props.part && this.props.part.name && (isStep1() || isStep2() || isStep3()) ? (
					<div className='model'>
						<label className='smaller'>{locale.model}</label>
						<div>
							<b>
								{Helper.getLocalizedValueOrNull(this.props.part.brandName) ??
									Helper.getLocalizedValueOrNull(this.props.part.title) ??
									this.props.part.name}
							</b>
						</div>
					</div>
				) : null}

				{this.props.part && this.props.part.price && Helper.userLoggedIn() && (isStep1() || isStep2() || isStep3()) ? (
					<div className='model'>
						<label className='smaller'>{locale.price}</label>
						<div>
							<b>
								{this.props.part.price.toLocaleString('de-DE', {
									style: 'currency',
									currency: this.props.document.currency,
								})}
							</b>
						</div>
					</div>
				) : null}
			</Fragment>
		);

		const showExposedBanner = this.props.theme && this.props.theme.showExposedBanner ? this.props.theme.showExposedBanner : false;
		const exposedBannerText = this.props.theme ? Helper.getLocalizedName(this.props.theme.exposedBannerText) : '';
		const exposedBannerUrl = this.props.theme ? this.props.theme.exposedBannerUrl : '';
		const exposedBannerColor = this.props.theme ? this.props.theme.exposedBannerColor : '#fff';
		const exposedBannerFontColor = this.props.theme ? this.props.theme.exposedBannerFontColor : '#fff';
		const buttonColor = this.props.theme ? this.props.theme.buttonColor : '#86A33C';
		const buttonFontColor = this.props.theme ? this.props.theme.buttonFontColor : '#fff';

		return (
			!isPublicDocuments && (
				<>
					{adminVisible && showExposedBanner && (
						<Navbar className='navbar-expand-lg navbar-toggleable-lg subnavbar navbar-light'>
							<Container fluid style={{ backgroundColor: exposedBannerColor, paddingLeft: 0, height: '30px' }}>
								<a
									href={exposedBannerUrl}
									target='_blank'
									rel='noopener noreferrer'
									className='AppFooterLink'
									style={{ paddingLeft: '15px', fontSize: '16px' }}
								>
									<span
										className='clearfix d-lg-inline-block'
										style={{ color: exposedBannerFontColor, display: 'inline-block', paddingRight: '10px' }}
									>
										{exposedBannerText}
									</span>
									<span className='fa fa-arrow-circle-right' style={{ color: exposedBannerFontColor }}></span>
								</a>
							</Container>
						</Navbar>
					)}
					<Navbar className='navbar-expand-lg navbar-toggleable-lg subnavbar navbar-light'>
						<Container fluid>
							<Collapse className='inline-flex' isOpen={this.state.isOpen} navbar>
								<ul className='navbar-nav subnavbar-nav flex-grow social d-flex'>
									{pathName.indexOf('/admin') === -1 || !adminVisible ? (
										<Fragment>
											{pathName.indexOf('/profile') === -1 || !(adminVisible || headOfSalesVisible || installerVisible) ? (
												<NavItem className='subnav-item'>
													<NavLink
														tag={RRNavLink}
														className='p-sm text-dark subnav-link'
														activeClassName='active'
														to={isExternal ? baseName + '/external-configurator/selection' : baseName + '/configurator/selection'}
														onClick={(e) => {
															// show confirmation dialog when admin is edition configuration
															if (adminVisible && !isExternal) {
																e.preventDefault();
																this.toggleConfirmationModal('/configurator/selection');
															}
														}}
													>
														{locale.configurationStep1}
													</NavLink>
												</NavItem>
											) : null}
											<NavItem className={'subnav-item ' + (configurationDisabled ? 'd-none' : '')}>
												<NavLink
													disabled={!this.props.part || !this.props.part.id}
													tag={RRNavLink}
													className='text-dark subnav-link'
													activeClassName='active'
													to={isExternal ? baseName + '/external-configurator/configuration' : baseName + '/configurator/configuration'}
												>
													{locale.configurationStep2}
												</NavLink>
											</NavItem>
											<NavItem className={'subnav-item ' + (configurationDisabled ? 'd-none' : '')}>
												<NavLink
													disabled={!this.props.part || !this.props.part.id}
													tag={RRNavLink}
													className='text-dark subnav-link'
													activeClassName='active'
													to={isExternal ? baseName + '/external-configurator/confirmation' : baseName + '/configurator/confirmation'}
												>
													{locale.configurationStep3}
												</NavLink>
											</NavItem>
											{adminVisible && !isExternal ? (
												<NavItem className='subnav-item'>
													<NavLink
														tag={RRNavLink}
														className='text-dark subnav-link'
														activeClassName='active'
														to={baseName + '/admin/myProjects'}
														onClick={(e) => {
															e.preventDefault();
															this.toggleConfirmationModal('/admin/myProjects');
														}}
													>
														{locale.myProjects}
													</NavLink>
												</NavItem>
											) : null}
										</Fragment>
									) : (
										<Fragment>
											{!installerVisible ? (
												<NavItem className='subnav-item'>
													<NavLink
														tag={RRNavLink}
														isActive={checkActiveMyProjects}
														className='text-dark subnav-link'
														activeClassName='active'
														to={baseName + '/admin/myProjects'}
													>
														{locale.myProjects}
													</NavLink>
												</NavItem>
											) : null}
											{headOfSalesVisible || installerVisible ? (
												<NavItem className='subnav-item'>
													<NavLink
														tag={RRNavLink}
														isActive={checkActiveAllProjects}
														className='text-dark subnav-link'
														activeClassName='active'
														to={baseName + '/admin/allProjects'}
													>
														{locale.allProjects}
													</NavLink>
												</NavItem>
											) : null}
											<NavItem className={'subnav-item ' + (documentDisabled ? 'd-none' : '')}>
												<NavLink
													tag={RRNavLink}
													id='customerViewEditingTitle'
													disabled={documentDisabled}
													isActive={checkActiveDocument}
													className='text-dark subnav-link'
													activeClassName='active'
													to={baseName + '/admin/document/configurations'}
												>
													{locale.documentEditing}
												</NavLink>
											</NavItem>
											<NavItem className={'subnav-item ' + (documentConfigurationDisabled ? 'd-none' : '')}>
												<NavLink
													tag={RRNavLink}
													id='customerViewEditingTitle'
													disabled={documentConfigurationDisabled}
													isActive={checkActiveConfiguration}
													className='text-dark subnav-link'
													activeClassName='active'
													to={baseName + '/admin/configuration/calculation'}
												>
													{locale.configurationEditing + configurationVersion}{' '}
												</NavLink>
											</NavItem>
										</Fragment>
									)}
								</ul>
								<div className='model-price-wrapper text-dark d-none d-lg-block'>{modelAndPriceDiv}</div>
							</Collapse>
							<NavbarToggler onClick={() => this.toggle()} className='mr-2 d-block d-lg-none' />
							<div className='navbar-title'>{navTitle}</div>
							<div className='model-price-wrapper text-dark d-block d-lg-none'>{modelAndPriceDiv}</div>
							<ErrorModal />
							<Modal size='lg' isOpen={this.state.confirmationModal} toggle={() => this.toggleConfirmationModal('')}>
								<ModalHeader toggle={() => this.toggleConfirmationModal('')}>{locale.viewChangeTitle}</ModalHeader>
								<ModalBody>
									{locale.viewChangeDescription}
									<br />
									<br />
									<Button
										className={'button btn-secondary my-2'}
										onClick={() => this.confirmRedirect()}
										style={{ backgroundColor: buttonColor, color: buttonFontColor }}
									>
										{locale.confirm}
									</Button>
									<Button
										className={'button btn-secondary my-2 ml-3'}
										onClick={() => this.toggleConfirmationModal('')}
										style={{ backgroundColor: buttonColor, color: buttonFontColor }}
									>
										{locale.cancel}
									</Button>
								</ModalBody>
							</Modal>
						</Container>
					</Navbar>
				</>
			)
		);
	}
}
const ConnectedSubNavMenu = connect(
	(state: any) => state.configurator,
	(dispatch) => bindActionCreators(actionCreators, dispatch),
)(SubNavMenu) as any;

export default withRouter(ConnectedSubNavMenu);
